// no use
import {BottomNavigation, BottomNavigationAction, styled} from "@mui/material";
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {getLocationPath} from "../utils/utils";
import {dispatch} from "../redux/store";
import {onPageTitle} from "../redux/slices/app";

export const TABBAR_TYPE = {
  ASSETS: 'assets',
  CARD: 'card',
  MINE: 'mine',
}

const StyledBottomBar = styled("div")({
  position: 'fixed',
  width: '100%',
  bottom: '0',
});

const Tabbar = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const [value, setValue] = useState(TABBAR_TYPE.ASSETS);

  useEffect(() => {
    const path = getLocationPath();
    _updateDefaultTabValue(path);
  }, []);

  useEffect(() => {
    _updatePageTitle(value);
  }, [value]);

  const _updateDefaultTabValue = (path) => {
    if (path) {
      setValue(path);
    }
  }

  const _updatePageTitle = (title) => {
    dispatch(onPageTitle(title));
  }

  const _onTabChange = (event, newValue) => {
    setValue(newValue);
    navigate(newValue.replace(TABBAR_TYPE.ASSETS, ''));
  }

  return <StyledBottomBar>
    <BottomNavigation
      position=""
      showLabels
      value={value}
      onChange={_onTabChange}
    >
      <BottomNavigationAction value={TABBAR_TYPE.ASSETS} label={t('assets')}
                              icon={<i className="iconfont icon-wallet"/>}/>
      <BottomNavigationAction value={TABBAR_TYPE.CARD} label={t('card')} icon={<i className="iconfont icon-card"/>}/>
      <BottomNavigationAction value={TABBAR_TYPE.MINE} label={t('mine')} icon={<i className="iconfont icon-me"/>}/>
    </BottomNavigation>
  </StyledBottomBar>
};

export default Tabbar;